<template>
  <div id="app">
    <div class="app flex-row align-items-center">
      <div class="container">
        <b-row class="justify-content-center">
          <b-col md="6">
            <div v-if="Loading == true">
              <div class="d-flex justify-content-center">
                <h1>Log Masuk</h1>
              </div>
              <br />
              <div class="d-flex justify-content-center">
                <PulseLoader float />
              </div>
            </div>
            <div v-else>
              <h1 style="text-align: center" class="mb-5">MyEduloan</h1>
              <b-card-group>
                <b-card no-body>
                  <b-card-body>
                    <b-form>
                      <h1 style="text-align: center">Pengesahan Email</h1>
                      <p class="text-muted" style="text-align: center">
                        Pengesahan email bagi log masuk ke akaun anda
                      </p>
                      <b-input-group class="mb-3">
                        <b-input-group-prepend>
                          <b-input-group-text>
                            <i class="icon-user"></i>
                          </b-input-group-text>
                        </b-input-group-prepend>
                        <b-form-input
                          type="text"
                          class="form-control"
                          placeholder="No Kad Pengenalan Anda"
                          autocomplete="identityNo"
                          v-model="identityNo"
                        />
                      </b-input-group>
                      <b-input-group class="mb-3">
                        <b-input-group-prepend>
                          <b-input-group-text>
                            <i class="icon-lock"></i>
                          </b-input-group-text>
                        </b-input-group-prepend>
                        <b-form-input
                          type="text"
                          class="form-control"
                          placeholder="Kod Pengesahan"
                          autocomplete="verificationCode"
                          v-model="verificationCode"
                        />
                      </b-input-group>
                      <b-row>
                        <b-col cols="12" class="text-center">
                          <b-button
                            variant="primary"
                            class="px-4"
                            @click="InsertVerificationCode"
                            >Hantar Kod Pengesahan</b-button
                          >
                        </b-col>
                      </b-row>
                      <br />
                        <strong>Nota:</strong>
                        <span class="text-danger ml-2">Disclaimer</span>
                      <p style="text-align: center">
                        Jika anda
                        <strong> tidak menerima e-mel pengesahan </strong> dalam
                        tempoh 1 jam dari masa pendaftaran, sila hubungi BPP
                      </p>
                      <p style="text-align: center">E-mel: <a href='mailto:ictbpp@mara.gov.my'>ictbpp@mara.gov.my</a></p>
                      <!-- <p style="text-align: center">Telefon:</p> -->
                      <p style="text-align: center">Waktu Operasi: 8.00pagi - 5.00petang (Isnin-Jumaat)</p>
                    </b-form>
                  </b-card-body>
                </b-card>
              </b-card-group>
            </div>
            <div v-if="this.Error === true">
              <b-alert show variant="warning">{{ Message }}</b-alert>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

export default {
  name: "Login",
  e1: "#app",
  components: {
    PulseLoader,
  },
  data: function () {
    return {
      publicPath: process.env.BASE_URL,

      verificationCode: "",

      Loading: false,
      Error: false,
      LoadingMyIdentity: false,
      Message: "",
      identityNo: null,
    };
  },
  methods: {
    InsertVerificationCode() {
      const formData = new FormData();

      formData.append("Code", this.verificationCode);
      formData.append("IdentityNo", this.identityNo);
      return this.$API
        .post(this.$VerifyCode, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            if ("Pengesahan berjaya." === response.data[0].message) {
              this.$dialog.alert('Anda telah berjaya membuat pengesahan email. Anda boleh log masuk ke portal MyEduloan')
                .then(function(dialog){
                  this.$router.go();
                });
              this.$router.push("/Login");
            } else {
              this.$dialog.alert("Anda tidak berjaya membuat pengesahan email.");
            }
          }
          else {
            console.log("Error API: " + this.$VerifyCode);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  /*
  computed: {
    UserCategory: {
      get: function () {
        return this.$store.getters["user/UserCategory"];
      },
      set: function (value) {
        this.$store.dispatch("user/updateUserCategory", value);
      },
    }
  }
*/
};
</script>
